import {connect} from "react-redux";

interface IProps {
  user: any,
  children: any,
  permissions: string[]
}

const Some = (props: IProps) => {
  const {companyAccess: uPerm = {}} = props.user;
  const {permissions} = props;
  const hasAccess = permissions.some((key: string) => !!uPerm[key]);
  return hasAccess
    ? props.children
    : null
};

export default connect(({
  user
}: any) =>
  ({
    user
  }))(Some);